// features/workstations/shared/source-trace.js
// ═══════════════════════════════════════════════════════════
// SOURCE TRACE — every AI-authored claim should link back to
// its underlying data. This primitive renders that link list
// as small chips with optional icons + click handlers.
//
// Used by Findings (linked trades + journals + uploads),
// Uploads (the source document under analysis), Works
// (version history + source conversation), Knowledge Feed
// (the article/event that spawned the practitioner lens).
//
// Sources prop = array of:
//   { label: string, kind?: 'trade' | 'session' | 'upload' | 'message' | 'doc',
//     onClick?: () => void, href?: string }
//
// Either onClick OR href — not both. If neither, renders as
// inert chip (display-only).
// ═══════════════════════════════════════════════════════════

const KIND_TONE = {
  trade:    'gold',
  session:  'teal',
  upload:   'sage',
  message:  'purple',
  doc:      'static',
};

export default function SourceTrace({
  sources,
  label = 'Source',
  inline = false,
}) {
  if (!Array.isArray(sources) || sources.length === 0) return null;

  return (
    <div className={`ws-source-trace${inline ? ' is-inline' : ''}`}>
      <span className="ws-source-trace-label">{label}:</span>
      {sources.map((s, i) => {
        const tone = KIND_TONE[s.kind] || 'static';
        const className = `ws-source-chip ws-source-chip-${tone}`;
        if (s.href) {
          return (
            <a key={i} className={className} href={s.href} target="_blank" rel="noopener noreferrer">
              {s.label} <span className="ws-source-chip-arrow">\u2192</span>
            </a>
          );
        }
        if (s.onClick) {
          return (
            <button key={i} type="button" className={className} onClick={s.onClick}>
              {s.label} <span className="ws-source-chip-arrow">\u2192</span>
            </button>
          );
        }
        return (
          <span key={i} className={`${className} is-inert`}>
            {s.label}
          </span>
        );
      })}
    </div>
  );
}
